module.exports = __webpack_public_path__ + "img/sitem_bg1.0e44efa4.png";